import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit3, FiUser, FiBriefcase, FiTrash2 } from 'react-icons/fi';
import { LoadingGrid } from '../../components/UI/Loading';
import BottomTabMenu from '../../components/UI/BottomTabMenu';
import ConfirmModal from '../../components/UI/Modal/ConfirmModal';
import { proveedoresService } from '../../services';

const ProveedorDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [proveedor, setProveedor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Tabs para el menú inferior
  const proveedorTabs = [
    {
      id: 'detalle',
      label: 'Datos Proveedor',
      route: ''
    },
    {
      id: 'ordenes',
      label: 'Órdenes de Compra',
      route: '/ordenes'
    },
    {
      id: 'notas',
      label: 'Notas',
      route: '/notas'
    }
  ];

  useEffect(() => {
    loadProveedorDetalle();
  }, [id]);

  const loadProveedorDetalle = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await proveedoresService.getProveedorById(id);

      if (result.success) {
        setProveedor(result.data);
      } else {
        setError(result.message || 'Error al cargar el proveedor');
      }
    } catch (error) {
      console.error('Error cargando proveedor:', error);
      setError('Error de conexión al cargar el proveedor');
    } finally {
      setIsLoading(false);
    }
  };


  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const result = await proveedoresService.deleteProveedor(id);
      if (result.success) {
        navigate('/system/proveedores', {
          state: {
            message: `Proveedor "${proveedor?.name || ''}" desactivado correctamente`,
            type: 'success'
          }
        });
      } else {
        console.error('Error al desactivar proveedor:', result.message);
      }
    } catch (error) {
      console.error('Error desactivando proveedor:', error);
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  // Estatus del proveedor (Activo/Inactivo/Pendiente/Bloqueado). No confundir
  // con el campo "Estado" de la dirección (state/provincia).
  const getStatusLabel = (estado) => {
    switch (estado) {
      case 'ACTIVE': return 'Activo';
      case 'INACTIVE': return 'Inactivo';
      case 'PENDING': return 'Pendiente';
      case 'BLOCKED': return 'Bloqueado';
      default: return 'Desconocido';
    }
  };

  const getStatusColor = (estado) => {
    switch (estado) {
      case 'ACTIVE': return '#16a34a';
      case 'INACTIVE': return '#6b7280';
      case 'PENDING': return '#d97706';
      case 'BLOCKED': return '#dc2626';
      default: return '#6b7280';
    }
  };

  if (isLoading) {
    return <LoadingGrid count={4} message="Cargando información del proveedor..." />;
  }

  if (error || !proveedor) {
    return (
      <div className="error-container">
        <h2>Proveedor no encontrado</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/system/proveedores')} className="btn btn--primary">
          <FiArrowLeft /> Volver a Proveedores
        </button>
      </div>
    );
  }

  return (
    <div className="cliente-form-page">
      {/* Header */}
      <div className="form-header">
        <button onClick={() => navigate('/system/proveedores')} className="btn btn--ghost">
          <FiArrowLeft /> Volver a Proveedores
        </button>

        <h1 className="form-title">
          {proveedor.name || 'DETALLES DEL PROVEEDOR'}
          <span
            style={{
              marginLeft: '12px',
              padding: '3px 12px',
              borderRadius: '999px',
              fontSize: '0.7em',
              fontWeight: 700,
              color: '#fff',
              verticalAlign: 'middle',
              backgroundColor: getStatusColor(proveedor.status)
            }}
          >
            {getStatusLabel(proveedor.status)}
          </span>
        </h1>

        <div className="form-actions">
          <button
            className="btn btn--outline"
            onClick={() => setShowDeleteModal(true)}
            type="button"
            disabled={isDeleting}
          >
            <FiTrash2 /> Eliminar
          </button>
          <button
            onClick={() => navigate(`/system/proveedores/${id}/editar`)}
            className="btn btn--primary"
          >
            <FiEdit3 /> Editar
          </button>
        </div>
      </div>

      {/* Contenido en formato de formulario (solo lectura) */}
      <div className="cliente-form">
        <div className="form-columns">
          {/* Columna Izquierda */}
          <div className="form-column">
            {/* Sección: Información de la Compañía */}
            <div className="form-section">
              <div className="section-header">
                <FiBriefcase className="section-icon" />
                <h2 className="section-title">Información de la Compañía</h2>
              </div>

              <div className="form-group">
                <label className="form-label">Nombre de la Compañía</label>
                <div className="form-value">{proveedor.name || 'N/A'}</div>
              </div>

              <div className="form-group">
                <label className="form-label">Dirección</label>
                <div className="form-value">{proveedor.address || 'N/A'}</div>
              </div>
<div className="form-group">                <label className="form-label">Unidad</label>                <div className="form-value">{proveedor.unit || 'N/A'}</div>              </div>

              <div className="form-group">
                <label className="form-label">País</label>
                <div className="form-value">{proveedor.country || 'N/A'}</div>
              </div>

              <div className="form-group">
                <label className="form-label">Ciudad</label>
                <div className="form-value">{proveedor.city || 'N/A'}</div>
              </div>

              <div className="form-group">
                <label className="form-label">Estado</label>
                <div className="form-value">{proveedor.state || 'N/A'}</div>
              </div>

              <div className="form-group">
                <label className="form-label">Código Postal</label>
                <div className="form-value">{proveedor.postal_code || 'N/A'}</div>
              </div>

              <div className="form-group">
                <label className="form-label">Página Web</label>
                <div className="form-value">
                  {proveedor.website ? (
                    <a href={proveedor.website} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>
                      {proveedor.website}
                    </a>
                  ) : 'N/A'}
                </div>
              </div>
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="form-column">
            {/* Sección: Información de Contacto */}
            <div className="form-section">
              <div className="section-header">
                <FiUser className="section-icon" />
                <h2 className="section-title">Contacto</h2>
              </div>

              <div className="form-group">
                <label className="form-label">Nombre del Contacto</label>
                <div className="form-value">{proveedor.contact_name || 'N/A'}</div>
              </div>

<div className="form-group">                <label className="form-label">Teléfonos</label>                {proveedor.phones && proveedor.phones.length > 0 ? (                  <div className="form-value">                    {proveedor.phones.map((phone, index) => (                      <div key={index} style={{ marginBottom: '4px' }}>                        <strong>{phone.type === 'mobile' ? 'Móvil' : phone.type === 'office' ? 'Oficina' : phone.type === 'home' ? 'Casa' : phone.type === 'fax' ? 'Fax' : 'Otro'}:</strong> {phone.number}                        {phone.is_primary && <span style={{ marginLeft: '8px', fontSize: '0.85em', color: '#28a745' }}>(Principal)</span>}                      </div>                    ))}                  </div>                ) : (                  <div className="form-value">N/A</div>                )}              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <div className="form-value">
                  {proveedor.email ? (
                    <a href={`mailto:${proveedor.email}`} style={{ color: '#3b82f6' }}>
                      {proveedor.email}
                    </a>
                  ) : 'N/A'}
                </div>
              </div>
            </div>

            {/* Sección: Términos de Pago */}
            <div className="form-section">
              <div className="section-header">
                <h3 className="section-title">Términos de Pago</h3>
              </div>

              <div className="form-group">
                <label className="form-label">Estado del Proveedor</label>
                <div className="form-value" style={{ fontWeight: 700, color: getStatusColor(proveedor.status) }}>
                  {getStatusLabel(proveedor.status)}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Términos de Pago (Días)</label>
                <div className="form-value">{proveedor.credit_days || 0} días</div>
              </div>

              <div className="form-group">
                <label className="form-label">Cantidad de Crédito</label>
                <div className="form-value">{proveedor.credit_limit || 0}%</div>
              </div>

              <div className="form-group">
                <label className="form-label">Tipo de Pago</label>
                <div className="form-value">
                  {proveedor.payment_method === 'COD' ? 'COD' :
                   proveedor.payment_method === 'CHECK' ? 'CHEQUE' :
                   proveedor.payment_method === 'BANK_TRANSFER' ? 'TRANSFERENCIA' :
                   proveedor.payment_method === 'ZELLE' ? 'ZELLE' :
                   proveedor.payment_method || 'N/A'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Menú inferior */}
      <BottomTabMenu baseRoute={`/system/proveedores/${id}`} tabs={proveedorTabs} currentTab="detalle" />

      {/* Modal de confirmación de borrado lógico */}
      <ConfirmModal
        isOpen={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
        title="Desactivar Proveedor"
        message={`¿Desactivar el proveedor "${proveedor?.name || ''}"? Seguirá en la base de datos como inactivo y podrá reactivarse luego.`}
        confirmText="Desactivar"
        cancelText="Cancelar"
        isLoading={isDeleting}
      />
    </div>
  );
};

export default ProveedorDetalle;
